import { render, staticRenderFns } from "./CharacterFaceInput.vue?vue&type=template&id=695ec452&lang=pug&"
import script from "./CharacterFaceInput.vue?vue&type=script&lang=js&"
export * from "./CharacterFaceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterFaceInput.vue"
export default component.exports